
import {Component, Vue} from "vue-property-decorator";
import StudyInstituteTable from "@/components/institute/StudyInstituteTable.vue";
import UserToInstituteAssignment from "@/components/institute/UserToInstituteAssignment.vue";
import StudyInstituteCreateDialog from "@/components/institute/StudyInstituteCreateDialog.vue";
import StudyInstituteEditDialog from "@/components/institute/StudyInstituteEditDialog.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {instituteAssignmentModule, instituteModule, rolesModule, studyInstitutesModule, usersModule} from "@/store";
import InstituteToUserAssignment from "@/components/institute/InstituteToUserAssignment.vue";

@Component({
  components: {
    StudyInstituteTable,
    StudyInstituteCreateDialog,
    StudyInstituteEditDialog,
    ConfirmDialog,
    UserToInstituteAssignment,
    InstituteToUserAssignment
  },
})
export default class Institutes extends Vue {
  async mounted() {
    await studyInstitutesModule.loadAll();
    await instituteModule.loadAll();
    await usersModule.loadAll();
    await rolesModule.loadAll();
    instituteAssignmentModule.resetCurrentStudyInstitute();
  }

  get isInstituteSelected() {
    return instituteAssignmentModule.hasCurrentStudyInstitute;
  }
}
